import { z } from 'zod';
import { allUserRoleSchema } from '../data.types.js';
import { bulkOperationTypeSchema, emailSchema, firstNameSchema, integerIdSchema, lastNameSchema, newPasswordSchema, passwordSchema, phoneNumberSchema, uuidSchema, } from './primitives.js';
// Additional Schemas for Group User Membership
export const UserMembershipRequestSchema = z.object({
    userIds: z.array(integerIdSchema).min(1)
});
// Password and Invitation Schemas
export const SendInvitationRequestSchema = z.object({
    userId: integerIdSchema,
    message: z.string().max(1000).optional()
});
export const ResetPasswordRequestSchema = z.object({
    userId: integerIdSchema,
    sendEmail: z.boolean().optional()
});
export const ConfirmPasswordResetSchema = z.object({
    token: z.string(),
    password: newPasswordSchema,
    confirmPassword: passwordSchema,
}).refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
});
export const ChangePasswordSchema = z.object({
    currentPassword: z.string().min(1),
    password: z
        .string()
        .min(8, 'Password must be at least 8 characters')
        .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
        .regex(/[0-9]/, 'Password must contain at least one number')
        .regex(/[^A-Za-z0-9]/, 'Password must contain at least one special character'),
    confirmPassword: z.string().min(1, 'Please confirm your password'),
}).refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
});
export const ForgotPasswordSchema = z.object({
    email: emailSchema
});
export const BulkOperationRequestSchema = z.object({
    operationType: bulkOperationTypeSchema,
    targetEntity: z.string().min(1),
    batchSize: z.number().min(1).max(1000),
    validateOnly: z.boolean()
});
export const CreateSubscriptionSchema = z.object({
    customerId: z.string(), // Stripe customer ID (e.g., cus_xxxxx)
    planType: z.enum(['basic', 'professional', 'enterprise']),
    startDate: z.string().min(1),
    endDate: z.string().min(1),
    autoRenew: z.boolean()
});
export const UpdateTenantSchema = z.object({
    name: z.string().min(1).max(100).trim(),
    subdomain: z.string().min(1).max(50).trim(),
    subscriptionPlanId: uuidSchema.optional(),
    isActive: z.boolean()
});
export const CreateTenantUserSchema = z.object({
    email: emailSchema,
    firstName: firstNameSchema,
    lastName: lastNameSchema,
    phone: phoneNumberSchema.optional(),
    role: allUserRoleSchema,
    password: passwordSchema
});
//# sourceMappingURL=tenant-access.schemas.js.map